import React, {Component} from 'react';
import styled from 'styled-components';
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import {toJS} from "../../to-js";
import * as Actions from "../../actions/actions";
import Tag from "./Tag";
import QuantityCounter from "../common/QuantityCounter";
import {priceFormat} from "../../formaters";
import {mixins} from "../../mixins";


const Price = styled.div`
  font-weight: ${p => !p.bold ? 500 : 'bold'};
  font-size: ${p => p.theme.sFontBig}px;
`;

const Thumbnail = styled.div`
  height: 40px;
  width: 40px;
  margin-right: 20px;
  img{
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }
`;

const Product = styled.div`
  display: flex;
  align-items: center;
  font-size: ${p => p.theme.sFontBig}px;
`;

const Total = styled.div`
  padding: 15px 0;
  border-top: 1px solid ${p => p.theme.cText};
  display: flex;
  justify-content: flex-end;
`;

const Table = styled.table`
  width: 100%;
  th{
    border-bottom: 1px solid ${p => p.theme.cText};
  }
  td{
    padding: 10px 0;
    &:last-child{
      width: 120px;
      text-align: right;
    }
  }
`;

const MessageContainer = styled.div`
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
`;

const Delete = styled.button`
  height: 30px;
  width: 30px;
  margin-left: -30px;
  display: block;
  position: relative;
  cursor: pointer;
  background: none;
  border: none;
  outline: none !important;
  &:before, &:after{
    ${mixins.pseudoToBlock()};
    height: 1px;
    width: 8px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -4px;
    background-color: ${p => p.theme.cBorderLight};
    transform: rotate(45deg);
    ${mixins.ease()};
  }
  &:after{
    transform: rotate(-45deg);
  }
  &:hover, &:focus{
    &:after, &:before{
      background-color: ${p => p.theme.cTheme};
    }
  }
`;

class CartPage extends Component {

    getProduct = (id) => {
        return this.props.products.filter((item) => item.id === id)[0];
    };

    getTotal = () => {
        let total = 0;
        const items = this.props.items;
        for (let i = 0; i < items.length; i++) {
            total += this.getProduct(items[i].product_id).price * items[i].quantity;
        }
        return priceFormat(total);
    };

    render() {
        if (this.props.items.length) {
            const items = this.props.items.map((item, key) => {
                const product = this.getProduct(item.product_id);
                return <tr key={key}>
                    <td>
                        <Delete onClick={() => this.props.removeFromCart({id: item.id})} aria-label="delete"/>
                    </td>
                    <td>
                        <Product><Thumbnail>
                            <img src={product.image} alt=""/>
                        </Thumbnail>
                            {product.size.x + '×' + product.size.y + ' mm'}</Product>
                    </td>
                    <td><Price>{priceFormat(product.price)}</Price></td>
                    <td>
                        <QuantityCounter id={item.id}/>
                    </td>
                    <td><Tag>Сетка</Tag><Tag>Airobox</Tag><Tag>Подоконник</Tag>
                        <button onClick={() => {
                            this.props.openAddToCartModal({
                                id: item.id,
                                product_id: product.id,
                            })
                        }
                        }>edit
                        </button>
                    </td>
                    <td><Price bold>{priceFormat(product.price * item.quantity)}</Price></td>
                </tr>
            });

            return (
                <React.Fragment>
                    <Table className={this.props.className}>
                        <tbody>
                        <tr>
                            <th/>
                            <th>Продукт</th>
                            <th>Цена</th>
                            <th>Количество</th>
                            <th>Модификации</th>
                            <th>Итого</th>
                        </tr>
                        {items}
                        </tbody>
                    </Table>
                    <Total>
                        <Price bold>{this.getTotal()}</Price>
                    </Total>
                </React.Fragment>
            );
        } else {
            return (
                <MessageContainer>Your cart is empty ;(</MessageContainer>
            )
        }
    }
}

function mapStateToProps(state) {
    return {
        items: state.getIn(['cart', 'items']),
        products: state.get('products'),
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        removeFromCart: Actions.removeFromCart,
        openAddToCartModal: Actions.openAddToCartModal,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(toJS(CartPage));